import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Monitor, Play, Smartphone, X } from "lucide-react";
import { HUD } from "./theme";

const SIZES = { desktop: [1440, 900], sideways: [844, 390] };

// Full-screen preview of a saved look: the real homepage rendered with that look, nothing goes live
export const LookPreview = ({ look, onClose, onApply }) => {
  const [device, setDevice] = useState("desktop");
  const box = useRef(null);
  const [fit, setFit] = useState(1);
  const [W, H] = SIZES[device];
  useEffect(() => {
    const calc = () => { const r = box.current?.getBoundingClientRect(); if (r) setFit(Math.min(1, r.width / W, r.height / H)); };
    calc();
    window.addEventListener("resize", calc);
    const esc = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", esc);
    return () => { window.removeEventListener("resize", calc); window.removeEventListener("keydown", esc); };
  }, [W, H, onClose]);
  const tab = (d) => `h-8 px-3 rounded-full text-xs border flex items-center gap-1.5 ${device === d ? "border-cyan-300 bg-cyan-400/15 text-white" : "border-cyan-400/15 text-gray-400"}`;
  return createPortal(
    <div className="fixed inset-0 z-[100] bg-black/95 flex flex-col" data-testid="look-preview">
      <div className="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-cyan-400/15">
        <p className="text-sm text-white mr-auto" data-testid="look-preview-title">Preview: {look.name} <span className="text-gray-500 text-xs">(not live)</span></p>
        <button onClick={() => setDevice("desktop")} className={tab("desktop")} data-testid="look-preview-desktop"><Monitor className="w-3.5 h-3.5" />Desktop</button>
        <button onClick={() => setDevice("sideways")} className={tab("sideways")} data-testid="look-preview-sideways"><Smartphone className="w-3.5 h-3.5 rotate-90" />Phone sideways</button>
        {!look.live && <button onClick={() => { onApply(look); onClose(); }} className={`${HUD.btn} h-8 px-3 text-xs flex items-center gap-1.5`} data-testid="look-preview-apply"><Play className="w-3.5 h-3.5" />Use this look</button>}
        <button onClick={onClose} className={`${HUD.ghost} h-8 w-8 flex items-center justify-center`} data-testid="look-preview-close"><X className="w-4 h-4" /></button>
      </div>
      <div ref={box} className="flex-1 flex items-center justify-center overflow-hidden p-4">
        <div style={{ width: W * fit, height: H * fit }} className={`overflow-hidden border border-cyan-400/20 ${device === "sideways" ? "rounded-[28px]" : "rounded-xl"}`}>
          <iframe key={device} title="Look preview" src={`/?preview_look=${look.id}`} style={{ width: W, height: H, transform: `scale(${fit})`, transformOrigin: "top left" }} className="border-0 bg-black" data-testid="look-preview-frame" />
        </div>
      </div>
    </div>,
    document.body,
  );
};
